<template>
  <router-link class="d-flex justify-content-center align-items-center flex-1 text-center"
    active-class="router-link-active" :to="item.path" :id="`tab-btn-${item.id}`" >
    <li class="nav-item">
        <i :class="`sidebar-icon ${item.icon}`"></i>
    </li>
  </router-link>
</template>

<script lang="ts">
import { ITabbarItem } from '@/interfaces';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'Tabbar',
  props: {
    item: {
      type: Object as PropType<ITabbarItem>,
      required: true
    }
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar-icon {
  font-size: 1.6rem
}
</style>
